import { mapState } from 'pinia';
import { useUserStore } from '@@/stores/User';
import { replaceHistoryState } from '@@/utils/CommonUtils';

export default {
  computed: {
    ...mapState(useUserStore, {
      units: (state) => state.preferences.units,
    }),
  },

  watch: {
    units() {
      this.updateLocation(this.location);
    },
  },

  mounted() {
    this.$el.addEventListener('save-custom-location', this.handleSaveCustomLocation);
    this.$el.addEventListener('update-custom-location', this.handleUpdateCustomLocation);
  },

  unmounted() {
    this.$el.removeEventListener('save-custom-location', this.handleSaveCustomLocation);
    this.$el.removeEventListener('update-custom-location', this.handleUpdateCustomLocation);
  },

  methods: {
    async handleSaveCustomLocation(event) {
      const { location } = event?.detail || {};

      if (location) {
        await this.updateLocation(location);
        this.updateUrl(location);
      }
    },

    handleUpdateCustomLocation(event) {
      const { location } = event?.detail || {};

      if (location?.id === this.location.id) {
        this.updateLocation(location);
      }
    },

    async updateLocation(location) {
      const { is_custom, slug } = location;
      const { units } = this;

      try {
        this.location = await this.fetchLocation({ is_custom, slug, units });
      }
      catch (e) {
        // Do nothing. The location couldn't be updated.
      }
    },

    updateUrl(location) {
      const { slug } = this.$route.params;

      if (slug !== location.slug) {
        const url = String(window.location.href).replace(slug, location.slug);
        replaceHistoryState(url);
      }
    },
  },
};

export const getSetupParams = () => {
  const { params, query } = useRoute();
  const userStore = useUserStore();

  const { is_custom } = query;
  const { slug } = params;
  const { units } = userStore.preferences;

  return { is_custom, slug, units };
};

export const handleAsyncData = async (context = {}) => {
  /* eslint camelcase: off */
  const {
    action,
    actionPayload = {},
    params,
    query,
    userStore,
  } = context;

  await userStore.getUnits();

  const { slug } = params;
  const { is_custom } = query;
  const { units } = userStore.preferences;

  const location = await action({
    is_custom,
    slug,
    units,
    ...actionPayload,
  });

  return location;
};
